// extracted by mini-css-extract-plugin
export var actionButton = "_df-0";
export var attachmentLine = "_df-1";
export var fileInput = "_df-2";
export var fileUploadWrapper = "_df-4";
export var footer = "_df-3";
export var modalContent = "_df-5";
export var paperclip = "_df-6";
export var quillEditor = "_df-7";